import * as React from "react"
import styled, { PolymorphicComponentProps } from "styled-components"
import { DeprecatedMenuListButton } from "./menuListButton"

const MenuItemCmp = styled.a`
  margin: 0.25rem 0;
  padding: 0;
  text-decoration: none;
  width: 100%;

  & button {
    width: 100%;
  }
`

const MenuListTitle = styled.span`
  flex: 1;
  padding-left: 0.25rem;
  text-align: left;
`

export type DeprecatedMenuItemProps<C extends React.ElementType> = PolymorphicComponentProps<
  "web",
  {
    icon: React.ReactNode
    mode: "light" | "dark"
    selected?: boolean
  },
  C,
  C
>

export const DeprecatedMenuItem = <C extends React.ElementType = "button">({
  icon,
  mode,
  selected,
  children,
  ...props
}: DeprecatedMenuItemProps<C>) => (
  <MenuItemCmp {...props}>
    <DeprecatedMenuListButton mode={mode} selected={selected}>
      {icon}
      <MenuListTitle>{children}</MenuListTitle>
    </DeprecatedMenuListButton>
  </MenuItemCmp>
)
